import { gql } from 'apollo-angular';

export const CUSTOMER_ADD = gql`
  mutation customerCreate($input: CustomerCreateInput!) {
    customerCreate(input: $input) {
      customer {
        acceptsMarketing
        email
        firstName
        lastName
        phone
      }
      customerUserErrors {
        field
        message
        code
      }
    }
  }
`

export const CUSTOMER_ACCESS_TOKEN_CREATE = gql`
  mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
    customerAccessTokenCreate(input: $input) {
      customerAccessToken {
        accessToken
      }
      customerUserErrors {
        message
      }
    }
  }
`

export const CUSTOMER_ACCESS_TOKEN_DELETE = gql`
  mutation customerAccessTokenDelete($customerAccessToken: String!) {
    customerAccessTokenDelete(customerAccessToken: $customerAccessToken) {
      deletedAccessToken
      deletedCustomerAccessTokenId
      userErrors  {
        field
        message
      }
    }
  }
`

export const CUSTOMER_RECOVER = gql`
  mutation customerRecover($email: String!) {
    customerRecover(email: $email) {
      customerUserErrors {
        code
        field
        message
      }
    }
  }
`

export const CUSTOMER_ACTIVATE = gql`
  mutation customerActivateByUrl($activationUrl: URL!, $password: String!) {
    customerActivateByUrl(activationUrl: $activationUrl, password: $password) {
      customer {
        email
        id
      }
      customerAccessToken {
        accessToken
      }
      customerUserErrors {
        code
        field
        message
      }
    }
  }
`

export const CUSTOMER_RESET = gql`
  mutation customerResetByUrl($resetUrl: URL!, $password: String!) {
    customerResetByUrl(resetUrl: $resetUrl, password: $password) {
      customer {
        email
        id
      }
      customerAccessToken {
        accessToken
      }
      customerUserErrors {
        code
        field
        message
      }
    }
  }
`

export const GET_CUSTOMER = gql`
  query getCustomer($customerAccessToken: String!) {
    customer(customerAccessToken: $customerAccessToken) {
      id
      firstName
      lastName
      acceptsMarketing
      email
      phone
      orders(first: 100) {
        edges {
          node {
            cancelReason
            canceledAt
            id
            name
            orderNumber
            phone
            processedAt
            financialStatus
            fulfillmentStatus
            billingAddress {
              address1
              address2
              city
              company
              country
              countryCodeV2
              firstName
              formatted
              id
              lastName
              name
              phone
              province
              provinceCode
              zip
            }
            shippingAddress {
              address1
              address2
              city
              company
              country
              countryCodeV2
              firstName
              formatted
              id
              lastName
              name
              phone
              province
              provinceCode
              zip
            }
            subtotalPrice {
              amount
            }
            successfulFulfillments {
              trackingCompany
              trackingInfo {
                number
                url
              }
            }
            totalPrice {
              amount
            }
            totalShippingPrice {
              amount
            }
            totalTax {
              amount
            }
            lineItems(first: 50) {
              edges {
                node {
                  title
                  currentQuantity
                  quantity
                  variant {
                    id
                    availableForSale
                    quantityAvailable
                    sku
                    title
                    price {
                      amount
                    }
                    weight
                    weightUnit
                    image {
                      url(transform: { maxHeight: 2000, maxWidth: 2000 })
                      altText
                      width
                      height
                      id
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`